import {
    DELETE_OBJECT,
    CLEAR_OBJECT,
  } from '../../actions/objectToDelete';

export default function objectToDelete(state = {}, action) {    
    switch (action.type) {        
        case DELETE_OBJECT:
            return Object.assign({}, state, action.payload);
        case CLEAR_OBJECT:
            return Object.assign({}, state, action.payload);
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/objectToDelete/index.js